// "Buy it now": skips the cart and opens checkout with just this product
(function () {
  function syncDisabled(buyNow) {
    var form = buyNow.closest('form');
    var submit = form && form.querySelector('[name="add"]');
    if (!submit) return;
    var update = function () { buyNow.disabled = submit.hasAttribute('disabled'); };
    update();
    new MutationObserver(update).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
  }

  function init() {
    document.querySelectorAll('[data-buy-now]').forEach(syncDisabled);
  }

  document.addEventListener('click', function (event) {
    var buyNow = event.target.closest('[data-buy-now]');
    if (!buyNow || buyNow.disabled) return;
    event.preventDefault();
    var form = buyNow.closest('form');
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    var qtyInput = form.id ? document.querySelector('input[name="quantity"][form="' + form.id + '"]') : null;
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    buyNow.setAttribute('aria-busy', 'true');
    window.location.href = '/cart/' + idInput.value + ':' + qty;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
